import { render, staticRenderFns } from "./managers.vue?vue&type=template&id=488c6456&scoped=true&"
import script from "./managers.vue?vue&type=script&lang=js&"
export * from "./managers.vue?vue&type=script&lang=js&"
import style0 from "./managers.vue?vue&type=style&index=0&id=488c6456&lang=scss&scoped=true&"
import style1 from "./managers.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./managers.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488c6456",
  null
  
)

export default component.exports